<template>
  <form id="forgotpassword" @submit.prevent="validateAndSubmit">
    <p>
      Vul hieronder uw e-mailadres in. Naar dit e-mailadres wordt een bericht met instructies gestuurd hoe uw wachtwoord opnieuw in te stellen.
    </p>
    <div class="formsectioncompound">
      <div class="jq_gridcontentarea">
        <input-field
          id="email"
          :$v="$v.email"
          :value="email"
          :required="true"
          :hide-label="true"
          validation-message-translation-name-space="forgotPasswordForm"
          placeholder="E-mailadres"
          name="email"
          @input="(v) => setEmail(v)"
        />
      </div>
      <div class="jq_gridcontentarea">
        <div class="wm-field large-12 columns">
          <button type="submit">Versturen</button>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import { required, email } from 'vuelidate/lib/validators'
import InputField from './fields/InputField'
import ShowAlertErrorHandler from '../../mixins/show-alert-error-handler'

export default {
  name: 'ForgotPasswordForm',
  components: {
    InputField
  },
  mixins: [ShowAlertErrorHandler],
  data: () => {
    return {
      email: ''
    }
  },
  validations: {
    email: {
      required,
      email
    }
  },
  methods: {
    validateAndSubmit () {
      if (!this.validate()) {
        return false
      }
      this.submit()
    },
    validate () {
      this.$v.$touch()
      return !this.$v.$invalid
    },
    setEmail (value) {
      this.email = value
    },
    async submit () {
      const returnUrl = [
        window.location.protocol,
        '//',
        window.location.host,
        this.$router.resolve({name: 'reset-password'}).href
      ].join('')

      try {
        await this.$container.authenticationClient.forgotPassword(this.email, returnUrl)
        this.showAlert(this.$t('forgotPasswordForm.successAlertMessage', {email: this.email}))
        this.$router.push({ name: 'login' })
      } catch (error) {
        this.showAlertForError(
          error,
          {401: this.$t('forgotPasswordForm.successAlertMessage', {email: this.email})},
          {401: { name: 'login' }}
        )
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/forms/ForgotPasswordForm.vue